import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '商品明细',
    auth: true,
    authorityValue: "store-statistics-management"
  },
  name: 'commodity',
  data: function data() {
    return {
      value1: '',
      total: 0,
      tableData: [],
      tableColumns: [],
      tableColumnAll: [{
        prop: 'browsePeople',
        label: '访客数',
        type: '',
        width: '150'
      }, {
        prop: 'browseCount',
        label: '浏览量',
        type: '',
        width: '150'
      }, {
        prop: 'favoriteCount',
        label: '关注数',
        type: '',
        width: '150'
      }, {
        prop: 'cartCount',
        label: '加购商品件数',
        type: '',
        width: '150'
      }, {
        prop: 'cartPeople',
        label: '加购客户数',
        type: '',
        width: '150'
      }, {
        prop: 'tradePeople',
        label: '成交客户数',
        type: '',
        width: '150'
      }, {
        prop: 'tradeCount',
        label: '成交单量',
        type: '',
        width: '150'
      }, {
        prop: 'orderPeople',
        label: '下单客户数',
        type: '',
        width: '150'
      }, {
        prop: 'orderCount',
        label: '下单单量',
        type: '',
        width: '150'
      }, {
        prop: 'orderRate',
        label: '下单转化率',
        type: '',
        width: '150'
      }, {
        prop: 'orderTradeRate',
        label: '下单成交转化率',
        type: '',
        width: '150'
      }, {
        prop: 'orderAmount',
        label: '下单金额',
        type: '',
        width: '150'
      }, {
        prop: 'tradeAmount',
        label: '成交金额',
        type: '',
        width: '150'
      }, {
        prop: 'tradeRate',
        label: '成交转化率',
        type: '',
        width: '150'
      }, {
        prop: 'goodsSpec1',
        label: '客单价',
        type: '',
        width: '150'
      }],
      active: true,
      checkList: ['访客数', '浏览量'],
      checkList2: ['加购商品件数', '加购客户数', '下单单量', '成交单量', '成交金额'],
      form: {
        storeId: "",
        storeName: "",
        timeRange: {
          start: "",
          end: ""
        },
        goodsName: "",
        goodsTypeId: "",
        goodsTypeFirst: "",
        goodsTypeSecond: ""
      },
      storeTypeOptions: [],
      storeTypeOptions2: []
    };
  },
  methods: {
    pagination: function pagination(item) {
      this.dataBind(item);
    },
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.goods(item);

              case 2:
                res = _context.sent;
                _this.tableData = res.records;
                _this.total = res.total;
                console.log('tableData', _this.tableData);
                _this.tableColumns = [];

                _this.checkList.forEach(function (e) {
                  _this.tableColumnAll.forEach(function (_e, _i) {
                    if (_e.label == e) {
                      _this.tableColumns.push(_e);
                    }
                  });
                });

                console.log('this.tableColumns1', _this.tableColumns);

                _this.checkList2.forEach(function (e) {
                  _this.tableColumnAll.forEach(function (_e, _i) {
                    if (_e.label == e) {
                      _this.tableColumns.push(_e);
                    }
                  });
                });

                console.log('this.tableColumns2', _this.tableColumns);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleClick: function handleClick(e) {
      var _this2 = this;

      console.log(e);
      this.checkList = e;
      console.log('this.checkList', this.checkList);
      this.tableColumns = [];
      var totalList = this.checkList.concat(this.checkList2);
      totalList.forEach(function (e) {
        _this2.tableColumnAll.forEach(function (_e, _i) {
          if (_e.label == e) {
            _this2.tableColumns.push(_e);
          }
        });
      });
    },
    handleClick2: function handleClick2(e) {
      var _this3 = this;

      this.checkList2 = e; // if(this.checkList2.length>5){
      //   this.checkList2.pop()
      //   return this.$message.error('一次最多只能选5个')
      // }

      console.log('this.checkList2', this.checkList2);
      this.tableColumns = [];
      var totalList = this.checkList.concat(this.checkList2);
      totalList.forEach(function (e) {
        _this3.tableColumnAll.forEach(function (_e, _i) {
          if (_e.label == e) {
            _this3.tableColumns.push(_e);
          }
        });
      });
    },
    handleInput: function handleInput(val) {
      this.dataBind(this.form);
    },
    storeGoodsTypes: function storeGoodsTypes(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_this4$$api$st, records;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$api.storeGoodsTypes(_objectSpread(_objectSpread({}, item), {}, {
                  pageSize: 999,
                  typeLevel: 1
                }));

              case 2:
                _yield$_this4$$api$st = _context2.sent;
                records = _yield$_this4$$api$st.records;
                _this4.storeTypeOptions = records;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleStoreChange: function handleStoreChange(e) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$_this5$$api$st, records;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.$api.storeGoodsTypes({
                  pageSize: 999,
                  preTypeId: e[0]
                });

              case 2:
                _yield$_this5$$api$st = _context3.sent;
                records = _yield$_this5$$api$st.records;
                _this5.storeTypeOptions2 = records;

                if (e.length > 0 && Array.isArray(e)) {
                  _this5.$set(_this5.form, 'storeGoodsTypeFirst', e[0]);
                }

                if (e.length <= 0 && Array.isArray(e)) {
                  _this5.$set(_this5.form, 'storeGoodsTypeFirst', '');
                }

                _this5.dataBind(_this5.form);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleStoreChange2: function handleStoreChange2(e) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var form;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                form = _this6.form;

                if (_this6.form.storeGoodsTypeFirst.length > 0 && Array.isArray(_this6.form.storeGoodsTypeFirst)) {
                  _this6.$set(_this6.form, 'storeGoodsTypeFirst', form.storeGoodsTypeFirst[0]);
                }

                if (e.length > 0 && Array.isArray(e)) {
                  _this6.$set(_this6.form, 'storeGoodsTypeId', e[0]);
                }

                if (e.length <= 0 && Array.isArray(e)) {
                  _this6.$set(_this6.form, 'storeGoodsTypeId', '');
                }

                _this6.dataBind(_this6.form);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    rangeDateChange: function rangeDateChange(e) {
      if (e === null) {
        this.form.timeRange.start = '';
        this.form.timeRange.end = '';
      } else {
        this.form.timeRange.start = e[0];
        this.form.timeRange.end = e[1];
      }

      this.dataBind(this.form);
    }
  },
  mounted: function mounted() {
    this.storeGoodsTypes();
    this.dataBind();
  }
};